import React, { ReactNode, useEffect, useState } from 'react';
import classNames from 'classnames';
import Spinner from '../Spinner';
import { useAppTranslate } from '../../../../hooks';
import { useSelector } from 'react-redux';

const randomize = () => Math.floor(1 + Math.random() * (50 - 1));

type LoadingScreenProps = {
  isLoading: boolean;
  isSideModal: boolean;
}

const LoadingScreen = ({ isSideModal }: LoadingScreenProps): ReactNode => {
  const [message, setMessage] = useState('');
  // @ts-ignore
  const isLoading = useSelector(state => state.alerts.isLoading);

  const translate = useAppTranslate();

  useEffect(() => {
    const interval = setInterval(() => {
      const loadingString = 'loading_message_';
      const newMessage = translate(loadingString + randomize());
      setMessage(newMessage);
    }, 5000);
  
    return () => {
      clearInterval(interval);
    }
  }, [message])

  useEffect(() => {
    const loadingString = 'loading_message_';
    const message = translate(loadingString + randomize());
    setMessage(message);
  }, []);

  return (isLoading
    ? (
      <div className={classNames('loading-screen', {
        'side-modal-loader': isSideModal,
      })}
      >
        <Spinner
          width={40}
          height={40}
          className='spinner'
        />
        <span>{message}</span>
      </div>
    )
    : null
  );
}

export default LoadingScreen;

